<template>
  <div>
    <dialog-edit-bill :is_edit='is_edit' :bill_id="bill_id" @closeDialog="handleCloseDialog" @doneUpdate='handleDoneUpdate'></dialog-edit-bill>
    <dialog-show-bill v-if="show_bill_dialog" :dialog="show_bill_dialog" :id="show_bill.id" @closeDialog="handleCloseShowDialog"></dialog-show-bill>
    <dialog-cancel-bill v-if="cancel_bill_dialog" :dialog="cancel_bill_dialog" :bill="cancel_bill" @closeDialog="handleCloseCancelDialog"></dialog-cancel-bill>
    <dialog-protest-bill v-if="protest_bill_dialog" :dialog="protest_bill_dialog" :bill="protest_bill" :loading="protestLoading === protest_bill?.id" @closeDialog="handleCloseProtestDialog" @confirm="handleConfirmProtest"></dialog-protest-bill>

    <date-search v-if="with_date_search" @onDateSearch="handleDateSearch"></date-search>
    <v-data-table
      mobile-breakpoint="1"
      :headers="comp_headers"
      :items="loading? [] : items"
      class="elevation-0"
      :search="resolvedSearch"
      ref='table'
      :loading='loading'
      :options.sync="paginationOptions"
      :server-items-length="serverItemsLength"
      :footer-props="{itemsPerPageOptions: [10, 25, 50, 100]}"
    >
      <template v-slot:top>
        <v-row justify="center" class="mt-2 mb-5">
          
          <v-col cols='4'>
            <v-card style="border-radius:12px">
              <v-card-text class="px-2 py-1">
                <v-row align="center" class="px-5 py-2" justify="center">
                    <v-icon class="mr-5" color='blue-grey darken-3'>mdi-cash-multiple</v-icon>
                    <div class="d-flex flex-column">
                      <span class="title">{{ total_value_all.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}</span>
                      <span class="caption grey--text">Total geral</span>
                    </div>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols='4'>
            <v-card style="border-radius:12px">
              <v-card-text class="px-2 py-1">
                <v-row align="center" class="px-5 py-2" justify="center">
                    <v-icon class="mr-5" color='blue-grey darken-3'>mdi-cash-multiple</v-icon>
                    <div class="d-flex flex-column">
                      <span class="title">{{ total_value_sum.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) }}</span>
                      <span class="caption grey--text">Página atual</span>
                    </div>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols='4'>
            <v-card style="border-radius:12px">
              <v-card-text class="px-2 py-1">
                <v-row align="center" class="px-5 py-2" justify="center">
                  <v-icon class="mr-5" color='blue-grey darken-3'>mdi-receipt</v-icon>
                  <div class="d-flex flex-column">
                    <span class="title">{{ serverItemsLength }} boletos</span>
                    <span class="caption grey--text">Total de boletos filtrados</span>
                  </div>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
          
        </v-row>
      </template>
      
      <template v-slot:item.attributes.nf_due="{item}">
        <span>
          {{ item.attributes.nf_due ? $moment(item.attributes.nf_due.substring(0,10)).format('L') : ''}}
        </span>
      </template>
      <template v-slot:item.attributes.place_name="{item}">
        <span style="text-wrap: nowrap;">
          {{ item.attributes.place_name}}
        </span>
      </template>
      <template v-slot:item.attributes.concluded_at="{item}">
        <span>
          {{ item.attributes.concluded_at ? $moment(item.attributes.concluded_at.substring(0,10)).format('L') : ''}}
        </span>
      </template>
      <template v-slot:item.attributes.canceled_date="{item}">
        <span>
          {{ item.attributes.canceled_date || '' }}
        </span>
      </template>

      <template v-slot:item.attributes.value="{item}">
        {{Number(item.attributes.value).toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'})}}
      </template>
      
      <template v-slot:item.nf_number="{item}">
        <span v-if="item.attributes.nf_number">{{item.attributes.nf_number}}</span>
        <v-btn v-if="!item.attributes.nf_number" color="primary" dark @click="editItem(item)" icon small> <v-icon small>mdi-pencil</v-icon> </v-btn>
      </template>
      <template v-slot:item.attributes.company="{item}">
        <span v-if="item.attributes.company">{{item.attributes.company}}</span>
        <v-btn v-if="!item.attributes.company" color="primary" dark @click="editItem(item)" icon small> <v-icon small>mdi-pencil</v-icon> </v-btn>
      </template>
      <template v-slot:item.attributes.our_number="{item}">
        <span v-if="item.attributes.our_number">{{item.attributes.our_number}}</span>
        <v-btn v-if="!item.attributes.our_number" color="primary" dark @click="editItem(item)" icon small> <v-icon small>mdi-pencil</v-icon> </v-btn>
      </template>


      <template v-slot:item.order="{item}">
        <div class="d-flex align-center">
          <div v-if="item.attributes.external_order_id" style="flex-wrap: nowrap; white-space: nowrap; ">
            #{{item.attributes.external_order_id}} 
          </div>
          <div v-if="item.attributes.order_id" style="flex-wrap: nowrap; white-space: nowrap; ">
            #{{item.attributes.order_id}} 
          </div>
        </div>
      </template>


      <template v-slot:item.attributes.sent="{item}">
        <template v-if="item.attributes.protested">
          <v-chip small color="warning" text-color="white"> PROTESTADO <v-icon small right>mdi-alert-circle</v-icon> </v-chip>
        </template>
        <template v-else-if="!item.attributes.sent">
          <v-chip small color="success" text-color="white"> Gerado <v-icon small right>mdi-plus-circle</v-icon> </v-chip>
        </template>
        <template v-else-if="item.attributes.sent && !(item.attributes.concluded_at || item.attributes.canceled_at)">
          <v-chip small color="primary" text-color="white"> Enviado <v-icon small right>mdi-check-circle</v-icon> </v-chip>
        </template>
        <template v-else-if="item.attributes.sent && item.attributes.concluded_at && !item.attributes.canceled_at">
          <v-chip small color="success" text-color="white"> Liquidado <v-icon small right>mdi-check-circle</v-icon> </v-chip>
        </template>
        <template v-else-if="item.attributes.sent && item.attributes.canceled_at">
          <v-chip small color="grey" text-color="white"> Cancelado <v-icon small right>mdi-close-circle</v-icon> </v-chip>
        </template>
      </template>

      <template v-slot:item.attributes.fiscal_note="{item}">
        <template>
          <v-chip v-if="!item.attributes?.fiscal_note?.id && item.attributes?.canceled" small color="grey" text-color="white"> 
            Cancelado <v-icon small right>mdi-close-circle</v-icon> 
          </v-chip>
          <v-chip v-if="!item.attributes?.fiscal_note?.id && !item.attributes?.canceled " small color="orange" text-color="white"> 
            NF-e pendente <v-icon small right>mdi-help-circle-outline</v-icon> 
          </v-chip>
          <v-chip v-if="item.attributes?.fiscal_note?.id" small color="success" text-color="white" @click="openNfeDialog(item.attributes.fiscal_note)"> 
            Visualizar NF-e 
            <v-icon small right>mdi-check-circle </v-icon> 
          </v-chip>
        </template>

      </template>

      <template v-slot:item.action="{item}">
        <div class="d-flex align-space-between">
          <v-btn color="primary" x-small fab class="elevation-0 mx-1" @click="showItem(item)" ><v-icon>mdi-eye</v-icon></v-btn>
          <v-btn color="error" x-small fab class="elevation-0 mx-1" @click="cancelBill(item)"><v-icon>mdi-cancel</v-icon></v-btn>
          <v-btn v-if="isDirector()" color="warning" x-small fab class="elevation-0 mx-1" :loading="protestLoading === item.id" @click="openProtestDialog(item)" title="Protestar boleto"><v-icon>mdi-gavel</v-icon></v-btn>
        </div>
      </template>
    </v-data-table>

    <v-dialog v-model="comment_dialog" v-if="comment_dialog" max-width="500px" transition="dialog-transition" >
      <v-card style="border-radius:12px">
        <v-card-title primary-title>
          <div class="headline mb-0">Comentário</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pt-5">
          {{ comment }}
        </v-card-text>
      </v-card>
    </v-dialog>
    <DialogNfInfo :dialog_nf_infos="dialog_nf_infos" :nf_infos="nf_infos"></DialogNfInfo>
  </div>
</template>

<script>

import Api from '@/api/index'

export default {
  name: "BillTable",
  components: {
    DateSearch: () => import('@/_backoffice/_financial/components/shared/DateSearch.vue'),
    // NewBillDialog: () => import('./NewBillDialog'),
    DialogEditBill: () => import('./DialogEditBill'),
    DialogShowBill: () => import('./DialogShowBill'),
    DialogCancelBill: () => import('./DialogCancelBill.vue'),
    DialogProtestBill: () => import('./DialogProtestBill.vue'),
    DialogOrdersPayedBySource: () => import("@/_backoffice/_financial/components/payment/shared/DialogOrdersPayedBySource.vue"),
    FileAttachment: () => import('@/components/shared/FileAttachment.vue'),
    DialogNfInfo: () => import('@/_backoffice/_financial/components/bill/shared/DialogNfInfo.vue'),
  },
  props: {
    items: {
      type: Array,
    },
    headers:{
      type: Array,
    },
    title:{
      type: String,
    },
    with_date_search: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    pagination: {
      type: Object,
      default: null
    },
    showCanceledColumns: {
      type: Boolean,
      default: false
    },
    /** Se informado, substitui o `search` interno (ex.: vindo do FilterData em concluídos). */
    tableSearch: {
      type: String,
      default: null
    },
  },
  data() {
    return {
      paginationOptions: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false
      },
      headers_default: [
        { text: 'Vencimento', value: 'attributes.nf_due' },
        { text: 'Módulo', value: 'attributes.place_name' },
        { text: 'Cliente', value: 'attributes.client_name' },
        { text: 'Valor (R$)', value: 'attributes.value' },
        { text: 'Núm. Documento', value: 'attributes.nf_number' },
        { text: 'Núm. Pedido', value: 'order' },
        { text: 'Empresa', value: 'attributes.company' },
        { text: 'Nosso Número', value: 'attributes.our_number' },
        { text: 'Estado', value: 'attributes.sent' },
        { text: 'NF-e', value: 'attributes.fiscal_note' },
        { text: 'Ação', value: 'action' },
      ],
      concluded_headers: [
        { text: 'Vencimento', value: 'attributes.nf_due' },
        { text: 'Módulo', value: 'attributes.place_name' },
        { text: 'Cliente', value: 'attributes.client_name' },
        { text: 'Valor (R$)', value: 'attributes.value' },
        { text: 'Núm. Documento', value: 'attributes.nf_number' },
        { text: 'Núm. Pedido', value: 'order' },
        { text: 'Empresa', value: 'attributes.company' },
        { text: 'Nosso Número', value: 'attributes.our_number' },
        { text: 'Concluido em', value: 'attributes.concluded_at' },
        { text: 'Concluido por', value: 'attributes.by_user' },
        { text: 'Estado', value: 'attributes.sent' },
        { text: 'NF-e', value: 'attributes.fiscal_note' },
        { text: 'Ação', value: 'action' },
      ],
      canceled_headers: [
        { text: 'Vencimento', value: 'attributes.nf_due' },
        { text: 'Módulo', value: 'attributes.place_name' },
        { text: 'Cliente', value: 'attributes.client_name' },
        { text: 'Valor (R$)', value: 'attributes.value' },
        { text: 'Núm. Documento', value: 'attributes.nf_number' },
        { text: 'Núm. Pedido', value: 'order' },
        { text: 'Empresa', value: 'attributes.company' },
        { text: 'Nosso Número', value: 'attributes.our_number' },
        { text: 'Cancelado em', value: 'attributes.canceled_date' },
        { text: 'Cancelado por', value: 'attributes.canceled_by' },
        { text: 'Estado', value: 'attributes.sent' },
        { text: 'NF-e', value: 'attributes.fiscal_note' },
        { text: 'Ação', value: 'action' },
      ],
      
      search: '',
      comment: '',
      comment_dialog: false,
      dialog_nf_infos: false,
      nf_infos: {},

      bill_id: null,
      is_edit: false,

      cancel_bill: null,
      cancel_bill_dialog: false,

      show_bill: null,
      show_bill_dialog: false,
      isUpdatingPagination: false,

      protest_bill: null,
      protest_bill_dialog: false,
      protestLoading: null,
    }
  },
  computed: {
    resolvedSearch() {
      return this.tableSearch != null ? this.tableSearch : this.search
    },
    serverItemsLength() {
      return this.pagination ? this.pagination.total_count : 0
    },
    comp_headers(){
      if (this.showCanceledColumns) return this.canceled_headers
      return this.items.some(el => el.attributes.status_id == 6) ? this.headers_default : this.concluded_headers
    },
    total_value_sum() {
      if (this.resolvedSearch && this.$refs.table){
        // console.log(this.$refs.table);
        return this.loading? 0 : this.$refs.table.internalCurrentItems.reduce((acc, one)=> acc + Number(one.attributes.value) ,0)
      }
      return this.loading? 0 :  this.items.reduce((acc, one)=> acc + Number(one.attributes.value) ,0)
    },
    total_value_all() {
      // Total de todos os boletos (não apenas os da página atual)
      return this.pagination && this.pagination.total_value ? this.pagination.total_value : 0
    },
    user_allowed() {
      return this.isManager() || this.isFinancial() || this.isAnalyst() || this.isDirector() || this.isSalesExecutive() || this.isCreditAnalyst()
    },
    total_bills() {
      if (this.resolvedSearch && this.$refs.table){
        return this.loading? 0 : this.$refs.table.internalCurrentItems.length
      }
      return this.loading? 0 : this.items.length
    }
  },
  watch: {
    pagination: {
      handler(newVal) {
        if (newVal && !this.isUpdatingPagination) {
          this.isUpdatingPagination = true
          this.paginationOptions.page = newVal.current_page
          this.paginationOptions.itemsPerPage = newVal.per_page
          this.$nextTick(() => {
            this.isUpdatingPagination = false
          })
        }
      },
      immediate: true
    },
    paginationOptions: {
      handler(newVal, oldVal) {
        if (newVal && this.pagination && !this.isUpdatingPagination) {
          // Se oldVal não existe, é a primeira vez, não emitir eventos
          if (!oldVal) return
          
          // Emitir eventos separadamente para evitar problemas
          if (newVal.sortBy?.[0] !== oldVal.sortBy?.[0] || newVal.sortDesc?.[0] !== oldVal.sortDesc?.[0]) {
            this.$emit('sortChange', {
              sortBy: newVal.sortBy?.[0] || null,
              sortDesc: !!newVal.sortDesc?.[0]
            })
          } else if (newVal.itemsPerPage !== oldVal.itemsPerPage) {
            // Quando muda itemsPerPage, resetar para página 1
            this.$emit('perPageChange', newVal.itemsPerPage)
          } else if (newVal.page !== oldVal.page) {
            // Quando muda apenas a página
            this.$emit('pageChange', newVal.page)
          }
        }
      },
      deep: true
    }
  },
  methods: {
    openNfeDialog(data){
      this.dialog_nf_infos = !this.dialog_nf_infos
      this.nf_infos = data
    },
    cancelBill(item) {
      this.cancel_bill = {...item};
      this.cancel_bill_dialog = true;
    },
    handleCloseCancelDialog() {
      this.cancel_bill = null;
      this.cancel_bill_dialog = false;
    },
    handleDoneUpdate(){
      this.is_edit = false
      this.bill_id = null
      this.$emit('doneUpdate')
    },
    handleDoneSent(){
      this.is_edit = false
      this.bill_id = null
      this.show_bill_dialog = false
      this.$emit('doneSent')
    },
    handleDoneConclude(){
      this.is_edit = false
      this.bill_id = null
      this.$emit('doneConclude')
    },
    editItem(item){
      this.bill_id = null
      this.is_edit = false
      setTimeout(() => {
        this.bill_id = item.id
        this.is_edit = true
      }, 500);
    },
    showItem(item){
      this.show_bill = {...item};
      this.show_bill_dialog = true;
    },
    handleCloseShowDialog() {
      this.show_bill = null;
      this.show_bill_dialog = false;
    },
    handleCloseDialog(e){
      this.bill_id = null
      this.is_edit = false
    },
    handleDoneNewBill(e){
      this.$emit('doneNewBill', e)
    },
    seeComment(comment) {
      this.comment = comment
      this.comment_dialog = true
    },
    handleDateSearch(e){
      this.$emit('dateSearched', e)
    },
    canProtest(item) {
      return item.attributes && !item.attributes.protested && !item.attributes.canceled && item.attributes.status_id !== 16 && (item.attributes.vrt_transaction_id || item.attributes.payment_id)
    },
    openProtestDialog(item) {
      this.protest_bill = { ...item }
      this.protest_bill_dialog = true
    },
    handleCloseProtestDialog() {
      this.protest_bill = null
      this.protest_bill_dialog = false
    },
    async handleConfirmProtest(bill) {
      if (!bill || !bill.id) return
      this.protestLoading = bill.id
      try {
        await Api.Bill.protest(bill.id)
        this.handleCloseProtestDialog()
        this.$emit('doneUpdate')
        this.$store && this.$store.dispatch('snackbar/show', { text: 'Boleto protestado com sucesso.', color: 'success' })
      } catch (err) {
        const msg = err?.response?.data?.errors?.[0] || err?.message || 'Erro ao protestar boleto.'
        this.$store && this.$store.dispatch('snackbar/show', { text: msg, color: 'error' })
      } finally {
        this.protestLoading = null
      }
    }
  },
}
</script>